<template>
  <main class="user_profile">
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.editProfile") }}</h3>
          </template>

          <template #right-element>
            <a @click="$router.go(-1)" class="btn btn-outline-primary button">
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </a>
          </template>
        </TopTemplate>
      </div>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <form v-if="!loading" novalidate @submit.prevent="onSubmitUpdateUser">
        <div class="alert alert-success" role="alert" v-if="is_created">
          
          {{ $t('info.updateProfle') }}
        </div>
        <div class="alert alert-danger" role="alert" v-if="errorExist">
          
          {{ $t('info.updateProfleEchouer') }}
        </div>
        <div class="row">
          <div class="col-12">
            <div class="general-info">
              <h3>{{ $t("title.infoGeneral") }}</h3>
              <div class="panel">
                <div class="row align-items-center">
                  <div class="col-xl-12 col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("user.firstName") }}
                            <sup>*</sup>
                          </label>
                          <div>
                            <input
                              v-model="user.first_name"
                              type="text"
                              class="form-control"
                              :class="
                                v$.user.first_name.$error ? 'is-invalid' : ''
                              "
                            />
                            <span
                              v-if="v$.user.first_name.$error"
                              class="invalid-feedback"
                            >
                              {{ v$.user.first_name.$errors[0].$message }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("user.lastName") }}
                            <sup>*</sup>
                          </label>
                          <div>
                            <input
                              v-model="user.last_name"
                              type="text"
                              class="form-control"
                              :class="
                                v$.user.last_name.$error ? 'is-invalid' : ''
                              "
                            />
                            <span
                              v-if="v$.user.last_name.$error"
                              class="invalid-feedback"
                            >
                              {{ v$.user.last_name.$errors[0].$message }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="simple-input">
                          <label class="label">{{ $t("user.phone") }}</label>
                          <div>
                            <input
                              v-model="user.phone"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="simple-input">
                          <label class="label"
                            >{{ $t("user.email") }} <sup>*</sup></label
                          >
                          <div>
                            <input
                              v-model="user.email"
                              type="text"
                              class="form-control"
                              :class="v$.user.email.$error ? 'is-invalid' : ''"
                            />
                            <span
                              v-if="v$.user.email.$error"
                              class="invalid-feedback"
                            >
                              {{ v$.user.email.$errors[0].$message }}
                            </span>
                            <span
                              v-if="v$.user.email.$error"
                              class="invalid-feedback"
                              >{{ v$.user.email.email.$message }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-xl-2 col-md-4 avatar_photo">
                    <div class="avatar">
                      <div class="avatar_edit">
                        <label for="studentPhoto">
                          <i class="ri-edit-2-line" />
                        </label>
                      </div>
                      <input
                        id="studentPhoto"
                        ref="uploadstudentPhoto"
                        name="photo"
                        type="file"
                        class="custom-file-input"
                        accept=".jpeg, .jpg, .png"
                        @change="onImageChange"
                      />
                      <label v-if="user.photo" for="studentPhoto">
                        <img
                          :src="user.photo"
                          :class="{ 'd-block': user.photo }"
                          class="img-thumbnail img-fluid"
                        />
                      </label>
                      <label v-else for="studentPhoto">
                        <img
                          src="/images/avatar_student.png"
                          alt="avatar"
                          class="avator img-fluid"
                        />
                      </label>
                    </div>
                    <span class="indice">{{ $t("info.formatPhoto") }}</span>
                    <span class="indice">{{ $t("info.sizeImage") }}</span>
                    <span v-if="errorDocSize" class="indice errorSizeDoc">{{
                      $t("error.errorTailleMsg")
                    }}</span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 bloc-top">
            <div class="general-info">
              <h3>{{ $t("title.password") }}</h3>
              <div class="row">
                <div class="col-md-4">
                  <div class="simple-input">
                    <label class="label">
                      {{ $t("user.actuelPassword") }}
                    </label>
                    <div>
                      <input
                        v-model="user.actuelPassword"
                        type="password"
                        class="form-control"
                        :class="{'is-invalid': v$.user.actuelPassword.$error || errorExist}"
                        />
                        <span v-if="v$.user.actuelPassword.$error" class="invalid-feedback">
                          {{ $t('info.pwdCaracter') }}
                        </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="simple-input">
                    <label class="label">
                      {{ $t("user.newPassword") }}
                    </label>
                    <div>
                      <input
                        v-model="user.newPassword"
                        type="password"
                        class="form-control"
                        :class="{'is-invalid': v$.user.newPassword.$error }"
                        />
                        <span v-if="v$.user.newPassword.$error" class="invalid-feedback">
                          {{ $t('info.pwdCaracter') }}
                        </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="simple-input">
                    <label class="label">
                      {{ $t("user.confirmPassword") }}
                    </label>
                    <div>
                      <input
                        v-model="user.confirmPassword"
                        type="password"
                        class="form-control"
                        :class="{'is-invalid': v$.user.confirmPassword.$error }"
                        />
                        <span v-if="v$.user.confirmPassword.$error" class="invalid-feedback">
                          {{ $t('error.pwdNoConforme') }}
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 buttons">
          <div class="button-right d-flex justify-content-end mb-4">
            <button
              type="submit"
              class="btn button btn-primary"
              :disabled="loading"
            >
              <i class="icon-Check" />
              {{ $t("button.envoi") }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import {
  required,
  helpers,
  email,
  numeric,
  minLength,
  sameAs,
} from "@vuelidate/validators";
import "@vuepic/vue-datepicker/dist/main.css";
import AuthService from "../../services/auth.service";

import { parsePhoneNumberFromString, isValidNumber } from "libphonenumber-js";
const isPhone = helpers.regex(/^[0-9]{8}/); //phone valid
const SIZE_IMAGE = 2;
export default {
  name: "EditUser",
  components: {
    TopTemplate,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      v$: useValidate(),
      validNumber: false,
      userId: null,
      first_name:"",
      admin: JSON.parse(localStorage.getItem("user")),
      last_name:"",
      user: new Form({
        last_name: "",
        first_name: "",
        photo: "",
        email: "",
        phone: "",
        actuelPassword: "",
        newPassword: "",
        confirmPassword: "",
      }),
      password:"",
      errorExist:false,
      errorDocSize: false,
      loading: false,
      is_created: false,
      userConnecter : []
    };
  },
  validations() {},
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  created() {
    this.userId = this.$route.params.id;
  },

  mounted() {
    this.getById();
  },
  validations() {
    return {
      user: {
        first_name: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        last_name: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        email: {
          email: helpers.withMessage(this.$t("validation.email"), email),
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        actuelPassword: { minLength: minLength(8) },
        newPassword: { minLength: minLength(8) },
        confirmPassword: { sameAsPassword: sameAs(this.user.newPassword) },
      },
    };
  },
  methods: {
    formatPhoneNumber(value, index) {
      if (value.length === 0) {
        this.validNumbers[index].valid = true;
        return;
      }
      let phoneNumber = parsePhoneNumberFromString(value, "TN");
      if (value) {
        if (!phoneNumber) {
          this.validNumbers[index].valid = true;
          return;
        }
        this.validNumbers[index].valid = isValidNumber(phoneNumber.number);
        if (phoneNumber && this.validNumbers[index].valid) {
          if (index === 2) {
            this.isUniquet(phoneNumber.formatNational());
            this.student.parents_tuteur[0].phone = phoneNumber.formatNational();
          } else {
            if (index === 0) {
              this.isUniquep(phoneNumber.formatNational());
            } else {
              this.isUniquem(phoneNumber.formatNational());
            }
            this.student.parents[index].phone = phoneNumber.formatNational();
          }
        } else if (phoneNumber.length > 2) {
          if (index === 2) this.student.parents_tuteur[0].phone = value;
          else this.student.parents[index].phone = value;
        }
      }
    },

    getById() {
      this.loading = true;

      AuthService.get(this.userId)
        .then((response) => {
          let data = response.data.data;
          console.log(response.data.data)
          this.user.first_name = data.first_name;
          this.user.last_name = data.last_name;
          this.user.phone = data.phone;
          this.user.email = data.email;
          this.password = data.password;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        })
        .finally(() => {});
        
    },
    onSubmitUpdateUser() {
      this.isValidate = true;
      this.v$.$validate();
      this.$nextTick(() => {
        if (document.querySelector(".is-invalid")) {
          let domRect = document
            .querySelector(".is-invalid")
            .getBoundingClientRect();
          window.scrollTo({
            left: domRect.left + document.documentElement.scrollLeft,
            top: domRect.top + document.documentElement.scrollTop - 90,
            behavior: "smooth",
          });
        }
      });
      if (!this.v$.$error) {
        let password = null;
        if(this.user.newPassword && this.user.newPassword !== ""){
          password = this.user.newPassword
        }
        let data = {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone: this.user.phone,
          password: password,
          current_password:this.user.actuelPassword
        };
       
        AuthService.update(this.userId, data)
          .then(() => {
            
            this.$store.state.auth.user.first_name = this.user.first_name;
            this.$store.state.auth.user.last_name = this.user.last_name;
            this.$store.state.auth.user.email = this.user.email;
            this.$store.state.auth.user.password = this.user.password;
            this.$store.state.auth.user.phone = this.user.phone;
            this.admin = this.$store.state.auth.user;
      
      // Store the updated admin object back in local storage
      localStorage.setItem("user", JSON.stringify(this.admin));
            this.is_created = true;
            this.loading = false;
            this.errorExist = false;
            this.scrollToTop();
          })
          .catch((error) => {
            this.is_created = false;
            this.errorExist= (error.response.status === 422);
            this.loading = false;
            this.scrollToTop();
          });
      } else {
        this.loading = false;
        this.is_created = false;
        //this.scrollToTop();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    checkFilesSize: _.throttle(function (file) {
      if (!file) {
        this.errorDocSize = false;
      }
      this.errorDocSize = file.size / 1024 / 1024 > SIZE_IMAGE;
    }, 300),
    onImageChange: function (e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onloadend = (file) => {
        const files = e.target.files[0];
        this.checkFilesSize(files);
        this.user.photo = reader.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style>
.disabled {
  color: gray;
  pointer-events: none !important;
  cursor: no-drop !important;
}
</style>
